import useFilterGroup from '../../../../../hooks/use-filter-group';
import { FilterGroupType } from '../../../../../types/filter-group';
import { DropdownListWithValueField } from '../../../../components/inputs/DropdownListWithValueField';
import MarkerText from '../../../../components/inputs/MarkerText';
import { useAppDispatch, useAppSelector } from '../../../../hooks/store-hooks';
import { setSetting } from '../../../../state/slices/settings-slice';
import { useSearchContext } from '../../context/SettingsSearchContext';

export function SettingsMyAirportsFilterGroup() {
    const search = useSearchContext();
    const filterGroups = useFilterGroup(FilterGroupType.airport);
    const selected = useAppSelector((x) => x.settings.myAirportFilterGroup);
    const dispatch = useAppDispatch();

    return (
        <div className="px-3 d-flex justify-content-between align-items-center gap-2">
            <div>
                <MarkerText highlight={search.term}>Airport filter group</MarkerText>
            </div>
            <div style={{ width: 300 }}>
                <DropdownListWithValueField
                    data={filterGroups.map((x) => ({ value: x.id, text: x.name }))}
                    value={selected}
                    defaultItem={{ text: 'None', value: null }}
                    onChange={(e) => dispatch(setSetting('myAirportFilterGroup', e.value))}
                />
            </div>
        </div>
    );
}
